module.exports = __webpack_public_path__ + "img/002-responsive-website.42632d5d.svg";